/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setPrivacySettings} from '../api'

export const useMutationSetPrivacySettings = createReactQueryMutationHook('setPrivacySettings', setPrivacySettings)
